
// import { BigCard } from './ElemBigView';
// import { bigCardWidth, bigCardHeight } from "../../components/elem-play/BigCardView.js";
// import { PlotViewElements } from "../dynplot/dragHandler";

export const bigCardWidth = 260;
export const bigCardHeight = 310;

export class ElemCard {

    constructor( caseIndex, smallCardIndex, rect, corner, container, iconStyler  ) {
        let cardOutline = ElemCard.newCardOutline( container, rect, corner ),
            cardBack = ElemCard.newCardBack( container, iconStyler, caseIndex, smallCardIndex, rect, corner );

        this.caseIndex = caseIndex; // case index, pre-filter
        this.smallCardIndex = smallCardIndex; // varies from caseIndex when filtering
        this.outline = cardOutline; // dashed outline SVG element
        this.back = cardBack; // card number and icon SVG element
        this.isHome = true;
        this.isDragged = false; // in a custom dragged position (not a standard home/plot/big card position?)

        // add cross-references
        cardOutline.data("card", this );
        cardBack.data("card", this );
    }

    destroy() {
        // remove raphael elements from paper before destroying
        this.outline.remove();
        delete this.outline;
        this.back.remove();
        delete this.back;
    }

    get cardNo() { return this.smallCardIndex+1 }

    static cardBorder = 15;     // size of border in card home
    static cardCorner = 8;
    static scale = 0.25; // small card is 1/4 of big card size (same proportions)
    static textYOffset = 0.2;    // fraction of height from top
    static iconYOffset = 0.6;    // fraction of height from top
    static tipYOffset = 0.9;     // fraction of height from top
    static tipXOffset = 1.0;      // fraction of width from left
    static cardWidth = Math.round( bigCardWidth * ElemCard.scale)
    static cardHeight = Math.round( bigCardHeight * ElemCard.scale)
    static cardIconSize = 0.5 * ElemCard.cardWidth;
    static cardIconBottom = (ElemCard.cardHeight * ElemCard.iconYOffset) + ElemCard.cardIconSize/2;
    static cardOutlineStroke = "#808080"; // "gray";
    static cardOutlineDash = '3,3';
    static cardOutlineFill = "#FFF";
    static cardOutlineDropFill = "#eee";
    static cardBackStroke = "#1D4CBC";
    static cardBackHighlight = "#001F87";
    static cardBackFill = "#E6E9F7";
    static cardNumFontSize = 14;

    static newCardOutline( playContainer, rect, corner ) {
        let outline = playContainer.paper.rect( 0, 0, rect.width, rect.height, corner )
            .attr({ stroke:ElemCard.cardOutlineStroke, fill:ElemCard.cardOutlineFill});
        outline.node.setAttribute('stroke-dasharray', ElemCard.cardOutlineDash );
        return outline;
    }

    static newCardBack( playContainer, iconStyler, caseIndex, smallCardIndex, bbox, corner ) {
        let Dyn = playContainer.Dyn,
            paper = playContainer.paper;

        paper.setStart();
        let rrect = paper.rect( 0, 0, bbox.width, bbox.height, corner )
                .attr({ stroke:ElemCard.cardBackStroke, 'stroke-width':2, fill:ElemCard.cardBackFill})
                .data("caseIndex",caseIndex)
                .data("smallCardIndex",smallCardIndex)
                .drag( dragCardMove, dragCardStart, dragCardEnd )
                .hover( hoverIn, hoverOut ); // note: touch devices call
        const textY = bbox.height*ElemCard.textYOffset,
            iconY = bbox.height*ElemCard.iconYOffset,
            iconRadius = ElemCard.cardIconSize/2;
        let text = paper.text(
                bbox.width*0.5, textY, ""+(1+smallCardIndex))
            .attr({"font-size":ElemCard.cardNumFontSize});
        let icon = paper.path(
                iconStyler.hasCustomCaseIcon() ?
                    iconStyler.calcCustomIconPath( bbox.width*0.5, iconY, iconRadius ) :
                    iconStyler.calcCirclePath( bbox.width*0.5, iconY, iconRadius ))
                .attr({ fill:Dyn.plotUtil.kCaseColor })
                .data("caseIndex",caseIndex)
                .data("smallCardIndex",smallCardIndex)
                .drag( dragCardMove, dragCardStart, dragCardEnd )
                .hover( hoverIn, hoverOut ); // note: touch devices call, or enable if isIconOnly
        let set = paper.setFinish();
        rrect.getSet = () => { return set; }
        icon.getSet = () => { return set; }
        set.getRRect = () => { return rrect; }
        set.getIcon = () => { return icon; }
        set.getText = () => { return text; }
        Dyn.plotUtil.disableMouseOverEvents( icon ); // until isIconOnly===true, see showHideCard()
        Dyn.plotUtil.disableMouseOverEvents( text );
        set.translate( bbox.x, bbox.y ); // use transform to move in paper coordinates
        return set;

        function hoverIn( event ) { // called with hoverIn event, or dragStart/dragMove on touch devices
            let caseIndex = this.data("caseIndex"),
                set = this.getSet(), // this === rrect OR icon
                rrect = set.getRRect(),
                icon = set.getIcon();
            set.toFront();
            if( playContainer.options.isIconOnly ) {
                playContainer.home.addGlow(icon);
            } else {
                rrect.attr( "stroke", ElemCard.cardBackHighlight );
            }
            rrect.data("tooltip", playContainer.getCardToolTip( caseIndex, smallCardIndex ));
            let bbox = rrect.getBBox();
            Dyn.toolTip.show( rrect, event, {
                x: bbox.x + bbox.width*ElemCard.tipXOffset,
                y: bbox.y + bbox.height*ElemCard.tipYOffset
            } );
        }
        function hoverOut( event ) { // called with hoverOut event, or dragEnd on touch devices
            let set = this.getSet(), // this === rrect OR icon
                rrect = set.getRRect();
            playContainer.home.removeGlow(); // remove glow if any
            rrect.attr( "stroke", ElemCard.cardBackStroke ); // restore stroke
            if( Dyn.toolTip.isMyElement( rrect ))
                Dyn.toolTip.hide();
            playContainer.layerElements();
        }
        function dragCardStart( x, y, event ) {
            let cardBack=this.getSet(), // this === rrect OR icon
                rrect=cardBack.getRRect(),
                bbox = rrect.getBBox();
            rrect.data( "startX", bbox.x );
            rrect.data( "startY", bbox.y );
            rrect.data("dragResult", {
                result:"start", caseIndex:rrect.data("caseIndex"), smallCardIndex:rrect.data("smallCardIndex"),
                leftHome:false, onBigCard:false, bigCardIndex:-1, transform:"" });
            cardBack.toFront();
            if( Dyn.environment.isTouchDevice() )
                hoverIn.call( this, event )
            Dyn.plotUtil.safeStopPropogation( event );
        }
        function dragCardMove( dx, dy, x, y, event ) {
            if( Dyn.environment.isTouchDevice() ) {
                hoverIn.call( this, event );
            }
            let cardBack=this.getSet(), // this === rrect OR icon
                rrect=cardBack.getRRect(),
                caseIndex = rrect.data("caseIndex"),
                smallCardIndex = rrect.data("smallCardIndex");
            cardBack.transform( "t"+(rrect.data("startX")+dx)+","+(rrect.data("startY")+dy));
            let isNotInPlot = ! playContainer.hasPlot(),
                cardBBox = new Dyn.mathUtil.Rect( rrect.getBBox()),
                cardHome = playContainer.home.isCardOverlappingHome( cardBBox, smallCardIndex ),
                cardBig = playContainer.big.isCardOverlappingBigCardArea( cardBBox, caseIndex ),
                cardConstraint = isCardOutsideDragArea( playContainer, cardBBox, smallCardIndex ),
                dragResult = rrect.data("dragResult");
            if( Dyn.toolTip.isMyElement( rrect )) {
                Dyn.toolTip.update( rrect, event, {
                    x: cardBBox.x + cardBBox.width*ElemCard.tipXOffset,
                    y: cardBBox.y + cardBBox.height*ElemCard.tipYOffset
                } );
            }
            dragResult.transform = null;
            if( cardConstraint ) {
                dragResult.result = cardConstraint.animateHome ? "home" : "constrain";
                dragResult.transform = "t"+cardConstraint.x+","+cardConstraint.y;
                dragResult.xy = { x:cardConstraint.x, y:cardConstraint.y };
            } else if( cardHome && isNotInPlot ) {
                dragResult.result = "home";
                dragResult.transform = "t"+cardHome.x+","+cardHome.y;
                if( dragResult.leftHome ) {
                    playContainer.home.highlightCardHome( true, smallCardIndex );
                }
            } else if(dx!==0 && dy!==0) {
                dragResult.result = "drag";
                dragResult.leftHome = true; // left home at least once
                dragResult.xy = { x:rrect.data("startX")+dx, y:rrect.data("startY")+dy };
                playContainer.home.highlightCardHome( false, smallCardIndex );
            }
            if( cardBig && isNotInPlot ) {
                if( dragResult.bigCardIndex >= 0 ) { // unhighlight old
                    playContainer.big.highlightBigCard( false, dragResult.bigCardIndex );
                }
                playContainer.big.highlightBigCard( true, cardBig.bigCardIndex, caseIndex );
                dragResult.result = "big card";
                dragResult.bigCardIndex = cardBig.bigCardIndex;
                dragResult.transform = ElemCard.transformToCoverBigCard( cardBBox, cardBig.bbox );
                dragResult.onBigCard = true;
            } else {
                dragResult.onBigCard = false;
                if( dragResult.bigCardIndex >= 0 ) {
                    playContainer.big.highlightBigCard( false, dragResult.bigCardIndex );
                }
            }
            //console.log("MOVE", dx, dy, dragResult )
            Dyn.plotUtil.safeStopPropogation( event );
        }
        function dragCardEnd( event ) {
            let cardBack=this.getSet(), // this === rrect OR icon
                rrect=cardBack.getRRect(),
                smallCard = rrect.data('card'),
                dragResult = rrect.data("dragResult");
            playContainer.home.highlightCardHome( false, smallCard.smallCardIndex );
            if( dragResult.bigCardIndex >= 0 ) {
                playContainer.big.highlightBigCard( false, dragResult.bigCardIndex );
            }
            Dyn.assert(["home","constrain","drag","big card","start"].includes(dragResult.result));
            smallCard.setIsHome( dragResult.result==="home" );
            if( ["constrain","drag"].includes(dragResult.result)) {
                smallCard.setIsDragged( true, dragResult.xy.x, dragResult.xy.y );
            }
            if( dragResult?.transform ) {
                playContainer.dropAnimationStart( dragResult );
                smallCard.animateCardTo( dragResult.transform,
                    (dragResult.result==="big card") ? playContainer.slowAnimation(): playContainer.fastAnimation(),
                    null, () => dropAnimationEnd(dragResult) );
            } else {
                playContainer.updateHomeState();
            }
            if( Dyn.environment.isTouchDevice() )
                hoverOut.call( this, event );
            //console.log("-END", dragResult, smallCard )
            Dyn.plotUtil.safeStopPropogation( event );
        }
        function isCardOutsideDragArea( playContainer, cardBBox, smallCardIndex ) {
            let bin = playContainer.play.bins.find((bin) => bin.hasSmallCardIndex( smallCardIndex ));
            return bin ? bin.getBinConstraintForCard( cardBBox /*, caseIndex */ )
                       : playContainer.home.getDragConstraintForCard( cardBBox, smallCardIndex );
        }
        function dropAnimationEnd( dragResult ) {
            playContainer.dropAnimationEnd( dragResult );
        }
    }

    static transformToCoverBigCard( smallCardBBox, bigCardBBox ) {
        let scale = 0.93 * bigCardBBox.width / ElemCard.cardWidth;
        return "t"+(bigCardBBox.centerX()-smallCardBBox.width/2)+","+(bigCardBBox.centerY()-smallCardBBox.height/2)
            +"s"+scale+","+scale;
    }

    animateCardTo( transform, speed, iconFillColor=null, handleAnimationEnd=null ) {
        this.back.animate({ transform:transform }, speed.time, speed.easing, handleAnimationEnd );
        if( iconFillColor ) { // change color; otherwise leave color as-is
            this.back.getIcon().animate( { fill: iconFillColor }, speed.time, speed.easing );
        }
    }

    moveCardTo( transform ) {
        this.back.attr({ transform:transform });
    }

    getHomeBBox() {
        return this.outline.getBBox();
    }

    save() {
        // save the card location in universal [0-1] coordinates based on position within paper
        let bbox = this.back.getBBox();
        return this._viewToNormalizedCoord( bbox.x, bbox.y )
    }

    restore( data, isDragged, speed, playContainer ) {
        // if the card was dragged, restore the custom card location from universal coordinates
        // NOTE: not used for cards that are home, in big card,
        // or in an ordered by, grouped by plot but never dragged.
        if( isDragged && data.x >= 0 && data.x <= 1 && data.y >=0 && data.y <= 1 ) {
            let vCoord = this._normalizedToViewCoord( data.x, data.y ), // (x,y) restored and scaled to view
                bin = playContainer.play.bins.find((bin) => bin.hasSmallCardIndex( this.smallCardIndex ));
            if( bin ) {
                // card was dragged within in a bin in a plot; make sure it is still in bin
                let oldBBox = this.back.getBBox() ,
                    restoredBBox = new playContainer.Dyn.mathUtil.Rect( vCoord.x, vCoord.y, oldBBox.width, oldBBox.height ),
                    constrainedXY = bin.getBinConstraintForCard( restoredBBox /*, this.caseIndex */ );
                if( constrainedXY ) { // if we need to adjust location
                    vCoord.x = constrainedXY.x;
                    vCoord.y = constrainedXY.y;
                }
            }
            this.setIsHome(false);
            this.setIsDragged( true, vCoord.x, vCoord.y );
            this.animateCardTo( "t"+vCoord.x+","+vCoord.y, speed );
            //console.log("restore card", this.cardNo, this );
        }
    }

    _normalizedToViewCoord( x, y ) {
        let paper = this.outline.paper;
        return { x:x * paper.width, y:y * paper.height }
    }

    _viewToNormalizedCoord( x, y ) {
        const screenPrecision = 5;
        let paper = this.outline.paper;
        return { x:(x / paper.width).toPrecision(screenPrecision), y:(y / paper.height).toPrecision(screenPrecision) }
    }

    /** set the isMissing true/false status, to note that the card can not be plotted (group by/order by),
     *  and so should be hidden from the plot. */
    setIsMissing( wantMissing ) {
        if( (this.isMissing() && !wantMissing) || wantMissing )
            console.log( "setIsMissing", this.back.getRRect().data("caseIndex"), wantMissing )
        this.back.getRRect().data("isMissing", wantMissing );
    }

    isMissing() {
        return this.back.getRRect().data("isMissing");
    }

    // /** set the filter status (true/false), if filtered, card should not be visible in the cards or play area. */
    // setIsFilteredOut( wantFilter ) {
    //     if( (this.isMissing() && !wantFilter) || wantFilter )
    //         console.log( "setIsFilteredOut", this.back.getRRect().data("caseIndex"), wantFilter )
    //     this.back.getRRect().data("isFiltered", wantFilter );
    // }

    showHideCard( isIconOnly, Dyn ) {
        let isMissing = this.back.getRRect().data("isMissing");
        if( isMissing ) {
            this.back.hide(); // hide entire card if in plot and missing
        } else if( isIconOnly ) {
            this.back.getRRect().hide();
            this.back.getText().hide();
            this.back.getIcon().show();
            Dyn.plotUtil.enableMouseOverEvents( this.back.getIcon() );
        } else {
            this.back.show(); // not missing and not icon-only
            // avoid flicker of tooltip by letting card back handle tooltips, not icons
            Dyn.plotUtil.disableMouseOverEvents( this.back.getIcon() );
        }
    }

    hideCardUnderBigCard( bigCardBBox ) {
        if( bigCardBBox ) {
            // if supplied, move the card to the bigCardBBox for later reveal with animateCardTo()
            let cardBBox = this.getHomeBBox(),
                transform = ElemCard.transformToCoverBigCard( cardBBox, bigCardBBox );
            this.moveCardTo( transform );
        }
        this.back.hide();
    }

    setIsHome( isHome ) {
        this.isHome = isHome;
    }

    setIsDragged( isDragged, x, y ) {
        this.isDragged = isDragged;
        this.dragCoords = isDragged ? this._viewToNormalizedCoord( x, y )
            : {};
    }

    getCardState( playContainer /* ElemPlayContainer */) {
        if( playContainer.play.isCardInPlayArea( this )) {
            return "in bin";
        } else if( playContainer.big.isCardInBigCardArea( this.caseIndex )) {
            return "in big card";
        } else if( this.isMissing()) {
            return "missing";
        } else if( this.isDragged ) {
            return "dragged";
        } else if( this.isHome ) {
            return "home";
        } else {
            return "unknown";
        }
    }

    /** get the fill color for the case icon, with optional attribute to color by attribute */
    static getCaseColor( Dyn, attribute, caseIndex ) {
        let colorScheme = {
                colorAttribute: attribute,
                caseFillColor: Dyn.plotUtil.kCaseColor,
            },
            color = Dyn.colorUtil.calcCaseColor( caseIndex, false, colorScheme );
        return color.colorString;
    }
}

export class ElemHomeView {

    constructor( Dyn, container ) {

        // references to other objects
        this.Dyn = Dyn;
        this.container = container;
        this.bounds = new Dyn.mathUtil.Rect(0,0,0,0); // area for cards laid out on table
        this.smallCards = []; // one card for each case not filtered
        this.caseToCardIndex = []; // needed if cases are filtered out
        this.iconStyler = new Dyn.IconStyler();
        this.glowElement = null;
        //this.filteredCasesDisplay = null;
    }

    destroy() {
        this.Dyn = null;
        this.container = null;
    }

    initVisuals() {
        let customIconPath = this.container.dataSet.getCustomCaseIcon(),
            paper = this.container.paper;
        if( customIconPath ) {
            this.iconStyler.setCustomCaseIcon( paper, customIconPath );
        }
        //this.filteredCasesDisplay = new FilteredCasesDisplay( this.Dyn, this.container );
    }

    updateVisuals() {
        // update the filter display
        // this.filteredCasesDisplay.update(
        //     this.container.dataSet, this.bounds );
        // position cards above the filter display
        this.makeAndPositionCards();
    }

    resize( newSize ) {
        let Dyn = this.Dyn;
        this.bounds.copyRect( newSize );
        this.bounds.addDebugRect( this.container.paper );
        Dyn.assertValidRect( this.bounds );
        this.updateVisuals();
    }

    /**
     * Position or re-position the small cards in the home area, creating them if needed,
     * except for those cards that have been dragged or are in the big Card area or plot.
     * The position of the outlines determine where a card goes when returned "home".
     * Used for first time initialization, restore from saved plot, and after view size changes.
     * Creates cards if they don't exist (typically when loaded for the first time).
     */
    makeAndPositionCards() {
        const numCards = this.container.dataSet.getNumCasesAfterFilter(),
            numCases = this.container.dataSet.getNumCasesPreFilter();
            //filterHeight = this.filteredCasesDisplay.bounds.height;
        const border = ElemCard.cardBorder,
            w = ElemCard.cardWidth,
            h = ElemCard.cardHeight,
            corner = ElemCard.cardCorner,
            colWidth = w+border,
            cols = Math.max( 1, Math.floor( (this.bounds.width - border) / colWidth )),
            rows = Math.max( 1, Math.ceil( numCards/cols )),
            rowHeightTiled = h+border,
            //rowHeightFitted = (this.bounds.height - (rowHeightTiled+Math.max(border,filterHeight)))/(rows-1),
            rowHeightFitted = (this.bounds.height - (rowHeightTiled+border))/(rows-1),
            leftBorder = (this.bounds.width - (cols * w) - (cols-1)*border)/2;
        // if needed, overlap cards to fit
        let rowHeight = Math.max( 1, Math.min( rowHeightTiled, rowHeightFitted )),
            Dyn = this.Dyn,
            cardRect = new Dyn.mathUtil.Rect( 0, 0, w, h ).offset( leftBorder, border ),
            smallCardIndex = 0; // warning: if filtering, smallCardIndex !== caseIndex
        // position all cards, creating them if needed
        for( let caseIndex = 0; caseIndex<numCases; caseIndex++ ) {
            if( this.container.dataSet.isCaseFilteredOut(caseIndex)) {
                this.caseToCardIndex[ caseIndex ] = -1; // skip this case
            } else {
                let card = this.smallCards[smallCardIndex];
                if( card && ( card.caseIndex !== caseIndex || card.smallCardIndex !== smallCardIndex )) {
                    card.destroy(); // probably the filter changed, we must delete then re-create the card
                    this.smallCards[smallCardIndex] = card = null;
                }
                this.caseToCardIndex[ caseIndex ] = smallCardIndex;
                card = card || this.addSmallCard( caseIndex, smallCardIndex, cardRect, corner  );
                card.outline.attr( { x: cardRect.x, y: cardRect.y } );
                if( !(this.container.play.isCardInPlayArea( card ) // is in a bin? playView positions it
                    || this.container.big.isCardInBigCardArea( caseIndex ) // is in a big card? bigCardView positions it
                    || card.isMissing()) ) { // is missing? playView hides card, no need to position
                    if( card.isDragged ) { // restore to same relative drag position
                        let n = card._normalizedToViewCoord( card.dragCoords.x, card.dragCoords.y );
                        card.back.transform( "t" + n.x + "," + n.y );
                        Dyn.assert( !card.isHome, "Card is home; " + card.getCardState( this.container ) );
                    } else { // move to home position
                        card.back.transform( "t" + cardRect.x + "," + cardRect.y );
                        Dyn.assert( card.isHome, "Card not home; " + card.getCardState( this.container ) );
                    }
                }
                if( (cardRect.right() + colWidth) > this.bounds.width ) {
                    cardRect.x = leftBorder;
                    cardRect.y += rowHeight; // next row
                } else {
                    cardRect.x += colWidth; // next column
                }
                this.Dyn.assert( ! this.container.dataSet.isCaseFilteredOut(card.caseIndex), "case index should be filtered out: "+card.caseIndex+" for card: "+card.smallCardIndex);
                ++smallCardIndex;
            }
        }
        // remove extra cards (e.g. if filter was changed)ś
        while( this.smallCards.length > numCards ) {
            this.container.removeCard( this.smallCards.pop());
        }
        this.caseToCardIndex.length = numCases;
        Dyn.assert( numCards <= numCases );
        Dyn.assert( numCards === this.smallCards.length );
    }

    /** construct a small card object and add to our array of smallCards */
    addSmallCard( caseIndex, smallCardIndex, rect, corner  ) {
        let card = new ElemCard( caseIndex, smallCardIndex, rect, corner, this.container, this.iconStyler  );
        this.smallCards[smallCardIndex] = card;
        this.Dyn.assert( this.smallCards.length <= this.caseToCardIndex.length );
        return card;
    }

    /** arrange small cards in z-order, card backs over outlines */
    layerElements( layerCardBacks ) {
        this.smallCards.forEach((c) => c.outline.toFront());
        if( layerCardBacks ) {
            this.smallCards.forEach( ( c ) => c.back.toFront() );
        }
    }

    highlightCardHome( onOff, smallCardIndex ) {
        this.Dyn.assertValidArray( this.smallCards, smallCardIndex );
        this.smallCards[smallCardIndex].outline.attr({ fill:onOff?ElemCard.cardOutlineDropFill:ElemCard.cardOutlineFill})
    }

    hideCardUnderBigCard( smallCardIndex, bigCardBBox = null /*optional*/ ) {
        this.smallCards[smallCardIndex]?.hideCardUnderBigCard( bigCardBBox );
    }

    animateCardToHome( smallCardIndex, speed, handleAnimationEnd=null ) {
        let card = this.smallCards[smallCardIndex],
            homeBBox = card.getHomeBBox();
        card.setIsMissing(false);
        card.showHideCard(false, this.Dyn);
        card.setIsHome( true );
        card.setIsDragged( false );
        card.animateCardTo( "t"+homeBBox.x+","+homeBBox.y,
            speed || this.container.fastAnimation(),
            this.container.iconColor(), handleAnimationEnd);
    }

    animateAllCardsHome() {
        this.Dyn.assert( !this.container.isIconOnly ); // caller should clear option first
        this.smallCards.forEach( (card) => {
            this.Dyn.assert( ! this.container.dataSet.isCaseFilteredOut(card.caseIndex), "case index should be filtered out: "+card.caseIndex+" for card: "+card.smallCardIndex);
            let homeBBox = card.getHomeBBox();
            card.setIsMissing(false);
            card.showHideCard(false, this.Dyn);
            card.setIsHome( true );
            card.setIsDragged( false );
            card.animateCardTo( "t"+homeBBox.x+","+homeBBox.y,
                this.container.slowAnimation(), this.container.iconColor());
        });
    }

    allCardsAreHome() {
        return !this.smallCards.find((card) => !card.isHome);
    }

    setCardsIconOnly( wantIconOnly ) {
        this.smallCards.forEach( (card) => {
            card.showHideCard( wantIconOnly, this.Dyn );
        });
    }

    isCardOverlappingHome( cardBBox, smallCardIndex ) {
        let Dyn = this.Dyn,
            card = this.smallCards[smallCardIndex],
            cardHomeBBox = new Dyn.mathUtil.Rect( card.getHomeBBox());
        return cardBBox.isOverlappingRect( cardHomeBBox ) ? cardHomeBBox : null;
    }

    /** if the card is outside the home area, return a new x,y location */
    getDragConstraintForCard( cardBBox, smallCardIndex ) {
        let Dyn = this.Dyn,
            bigCardsViewBounds = this.container.big.bounds,
            homeViewBounds = this.bounds;
        if( bigCardsViewBounds.isOverlappingRect( cardBBox )) {
            if( ! bigCardsViewBounds.isPointInRect( cardBBox.centerX(), cardBBox.centerY())) {
                return {    // constrain card center to the inside of the big card view
                    x: Dyn.mathUtil.clipToMinMax(
                        bigCardsViewBounds.left() - cardBBox.width / 2,
                        bigCardsViewBounds.right() - cardBBox.width / 2, cardBBox.x ),
                    y: Dyn.mathUtil.clipToMinMax(
                        bigCardsViewBounds.top() - cardBBox.height / 2,
                        bigCardsViewBounds.bottom() - cardBBox.width / 2, cardBBox.y ),
                };
            }
        } else if( ! homeViewBounds.isPointInRect( cardBBox.centerX(), cardBBox.centerY() )) {
            // move card back to home if it is outside both big cards and home views
            let card = this.smallCards[smallCardIndex],
                cardHomeBBox = new Dyn.mathUtil.Rect( card.getHomeBBox());
            return { x:cardHomeBBox.x, y:cardHomeBBox.y, animateHome:true };
        }
        return null;
    }

    // add glow effect to one card or part of a card, only one element glows at a time
    addGlow( element ) {
        this.removeGlow();
        this.glowElement = element.glow( {
            color: element.attr('stroke'),
            colorwidth: this.Dyn.plotUtil.glowWidth
        });
    }

    // remove the glow, if any
    removeGlow() {
        this.glowElement?.remove();
        this.glowElement = null;
    }

    getHomeState() {
        return {
            plot: this.allCardsAreHome() ? "home" : "leftHome"
        };
    }

    isInHomeState() {
        switch( this.container.state.plot ) {
            case "home":
            case "leftHome":
                return true;
        }
        return false; // cards may be in big cards or in play area.
    }

    saveCards() {
        let Dyn = this.Dyn,
            data = [],
            hasData = false;
        // save custom card location only for cards that need it:
        //  cards that were dragged from home, or dragged within plot bin.
        this.smallCards.forEach( (card, cardIndex) => {
            if( card.isDragged && ! this.container.big.isCardInBigCardArea( card.caseIndex )) {
                data.push( card.save());
                Dyn.assertFiniteNumeric( data[data.length-1].x );
                Dyn.assertFiniteNumeric( data[data.length-1].y );
                hasData = true;
            } else {
                data.push({});
            }
        });
        return hasData ? data : [];
    }

    restoreCards( data ) {
        let Dyn = this.Dyn,
            speed = this.container.slowAnimation();
        // restore those cards that are in a custom (dragged) position (see saveCards())
        data?.forEach( (xy, index) => {
            if( Dyn.mathUtil.isInIntegerRange( index, 0, this.smallCards.length )) {
                this.smallCards[index].restore( xy, true, speed, this.container );
            }
        });
        if( this.isInHomeState()) {
            // update the state from "home" to/from "leftHome" (cards in custom-dragged position)
            this.container.setState( this.getHomeState() );
        }
    }

    /** get the small card index from a case index; returns -1 if case filtered out, etc */
    caseIndexToSmallCardIndex( caseIndex ) {
        let smallCardIndex = this.caseToCardIndex[ caseIndex ];
        if( smallCardIndex >= 0 && smallCardIndex < this.smallCards.length ) { // make sure it was not filtered out
            return smallCardIndex;
        }
        return -1;
    }
}

export class FilteredCasesDisplay {
    /** construct a filtered cases display for the TuvaJr home view.
     * see also PlotView.excludedCasesDisplay and PlotView.excludedCasesRect which this is based on. */
    constructor( Dyn, container, alignment ) {
        this.Dyn = Dyn;
        this.container = container;
        this.bounds = new Dyn.mathUtil.Rect(0,0,0,0); // display area within container.paper
        this.alignment = alignment; // "top-right" or "bottom"

        let paper = this.container.paper,
            fontSize = Dyn.preferences.getFontSize( Dyn.plotUtil.excludedCasesFontSize );
        this.numFilteredText = paper.text( 0, 0, "" )
            .attr({ "font-size":fontSize } )
            .hide();
        this.filterIcon = paper.path( Dyn.plotUtil.getFilterIcon( Dyn.plotUtil.fileredCaseIconSize ))
            .attr({stroke:"none", fill:"black" })
            .hide();
        this.coverRect = paper.rect( 0, 0, 0, 0 )
            .attr( Dyn.debugViewRects ?
                { fill: "none", stroke: "orange", opacity: 0.5 } : // make visible for debugging
                { fill: "gray", stroke: "none", opacity: 0.01 } )
            .data( "tooltip", "" )
            .data( "numFiltered", 0 )
            .hover( hoverIn, hoverOut )
            .hide();

        function hoverIn( event ) {
            // show "n case(s) missing" and/or "n case(s) filtered" tooltip
            // based on excludedCasesHoverOver()
            let missingCases = caseOrCases( this.data( "numMissing" ), false ),
                filteredCases = caseOrCases( this.data( "numFiltered" ), true ),
                txt = (missingCases ? missingCases + "\n" : "") + filteredCases;
            this.data( { "tooltip": txt } );
            Dyn.toolTip.show( this, event, {
                x: this.getBBox().x2, y: this.getBBox().y2 + 20
            } );

            function caseOrCases( number, isFilter ) {
                if( number > 0 ) {
                    if( isFilter ) {
                        return (number === 1) ? Dyn.loc( "1 case filtered" ) :
                            Dyn.loc( "{{n}} cases filtered", { n: number } );
                    } else {
                        return (number === 1) ? Dyn.loc( "1 case with missing values" ) :
                            Dyn.loc( "{{n}} cases with missing values", { n: number } );
                    }
                }
                return "";
            }
        }

        function hoverOut() {
            this.data( { "tooltip": "" } );
            if( Dyn.toolTip.isMyElement( this ) )
                Dyn.toolTip.hide();
        }
    }

    update( dataSet, parentBounds ) {
        let Dyn = this.Dyn,
            numFiltered = dataSet.caseFilter.numCasesFiltered;
        const isTopRight = this.alignment==="top-right"
        if( isTopRight ) {
            // start with our bounds at top of parent bounds
            this.bounds.removeDebugRect( this.container.paper );
            this.bounds = new Dyn.mathUtil.Rect( parentBounds );
            this.bounds.x = parentBounds.right();
            this.bounds.width = 0;
        } else {
            // start with our bounds at bottom of parent bounds
            this.bounds.removeDebugRect( this.container.paper );
            this.bounds = new Dyn.mathUtil.Rect( parentBounds );
            this.bounds.y = parentBounds.bottom();
        }

        // now add, update, or remove display
        if( numFiltered > 0 ) {
            // show filter display
            const yIcon = 2, // offset slightly to align with text
                fontSize = Dyn.preferences.getFontSize( Dyn.plotUtil.excludedCasesFontSize ),
                textOffset = fontSize - 0,
                iconOffset = isTopRight? Dyn.plotUtil.fileredCaseIconSize : 0;
            this.bounds.height = (isTopRight? 1:-1) * fontSize * 3;
            this.bounds.normalize();
            let x = isTopRight ? this.bounds.right() : this.bounds.centerX(),
                y = this.bounds.top() + fontSize;
            this.filterIcon.attr({ opacity: 1 })
                .transform( "t" + (x-iconOffset) + "," + (y+yIcon) )
                .show();
            this.numFilteredText.attr({
                text:"-"+numFiltered, x:x-textOffset-iconOffset, y:y, opacity:1, "text-anchor":"end", 'font-size':fontSize } )
                .show();
            let bbox = new Dyn.mathUtil.Rect( this.filterIcon.getBBox());
            bbox.union( new Dyn.mathUtil.Rect( this.numFilteredText.getBBox()));
            this.coverRect.attr({ x:bbox.x, y:bbox.y, width:bbox.width, height:bbox.height })
                .show();
            if( isTopRight ) {
                this.bounds.width = bbox.width;
                this.bounds.x = x - bbox.width
            }
        } else {
            // hide filter display
            this.bounds.height = 0;
            this.filterIcon.hide();
            this.numFilteredText.hide();
            this.coverRect.hide();
        }
        this.coverRect.data( "numFiltered", numFiltered );
        this.bounds.addDebugRect( this.container.paper );
        Dyn.assertValidRect( this.bounds );
        return this.bounds.height;
    }
}
